/**
 * Campo de dinheiro em CLP: o usuário digita só dígitos e o campo mostra "$50.000" enquanto
 * escreve. Qualquer `<input class="money">` da página ganha o comportamento; quem lê o valor
 * usa `parseMoney`, que ignora tudo que não é dígito.
 */
const fmt = new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 });

/** 1234567 → "$1.234.567"; 0/vazio → "" */
export function formatMoney(value: number | string | null | undefined): string {
  const n = typeof value === 'number' ? value : parseMoney(value ?? '');
  return n > 0 ? `$${fmt.format(n)}` : '';
}

/** "$50.000" | "50000" | "50.000,00" → 50000 (inteiro, CLP não tem centavos) */
export function parseMoney(raw: string): number {
  const digits = raw.replace(/[^\d]/g, '');
  return digits ? parseInt(digits, 10) : 0;
}

/** Formata um campo e mantém o cursor no fim (o formato muda o tamanho do texto). */
function format(el: HTMLInputElement): void {
  const n = parseMoney(el.value);
  el.value = n > 0 ? formatMoney(n) : '';
}

/** Liga a formatação em toda a página, inclusive em campos criados depois (delegação). */
export function installMoneyInputs(root: ParentNode = document): void {
  root.addEventListener('input', e => {
    const el = e.target as HTMLElement;
    if (el instanceof HTMLInputElement && el.classList.contains('money')) format(el);
  });
}

/** Aplica o formato nos campos já preenchidos por código (ex.: ao abrir um item para editar). */
export function refreshMoneyInputs(root: ParentNode = document): void {
  root.querySelectorAll<HTMLInputElement>('input.money').forEach(format);
}
